import React, { Component } from 'react'
import TestNavigationBar from '../components/TestNavigationBar';
import { TestQuestions1 } from './TestQuestions1';
import TestQuestions2 from './TestQuestions2';
import TestQuestions3 from './TestQuestions3';
import TestQuestions4 from './TestQuestions4';
import TestQuestions5 from './TestQuestions5';
import TestQuestions6 from './TestQuestions6';
import TestResult from './TestResult';

// CLASS WITH METHODS FOR THE QUESTIONNAIRE. CONTROL OF THE SWITCH OF "PAGES" IN THE QUESTIONNAIRE

export default class TestClass extends Component {

  state = {
    step: 1,
    qst1_1: '', qst1_2: '',
    qst2_1: '', qst2_2: '', qst2_3: '', qst2_4: '',
    qst3_1: '', qst3_2: '', qst3_3: '', qst3_4: '',
    qst4_1: '', qst4_2: '', qst4_3: '', qst4_4: '', qst4_5: '',
    qst5_1: '', qst5_2: '', qst5_3: '', qst5_4: '', qst5_5: '',
    qst6_1: '', qst6_2: '', qst6_3: '', qst6_4: '', qst6_5: ''
  }

  // PRE-DEFINED VALUES FOR DEVELOPMENT AND FUNCTIONALITY TESTING

  //state = {
  //    step: 1,
  //    qst1_1: '', qst1_2: '',
  //    qst2_1: 'Uenig', qst2_2: 'Meget enig', qst2_3: 'Enig', qst2_4: 'Uenig',
  //    qst3_1: 'Hverken enig eller uenig', qst3_2: 'Uenig', qst3_3: 'Uenig', qst3_4: 'Hverken enig eller uenig',
  //    qst4_1: 'Meget enig', qst4_2: 'Enig', qst4_3: 'Hverken enig eller uenig', qst4_4: 'Meget enig', qst4_5: 'Meget enig',
  //    qst5_1: 'Uenig', qst5_2: 'Hverken enig eller uenig', qst5_3: 'Enig', qst5_4: 'Hverken enig eller uenig', qst5_5: 'Meget enig',
  //    qst6_1: 'Enig', qst6_2: 'Meget enig', qst6_3: 'Hverken enig eller uenig', qst6_4: 'Meget enig', qst6_5: 'Meget enig'
  //}

  // go back to previous step
  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  }

  // proceed to the next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  }

  // proceed to results - FOR DEVELOPMENT AND TESTING
  toResults = () => {
    this.setState({ step: 7 });
  }

  // handle field change
  handleChange = input => (e) => {
    this.setState({ [input]: e.target.value });
  }

  render() {
    const { step } = this.state

    const { qst1_1, qst1_2,
      qst2_1, qst2_2, qst2_3, qst2_4,
      qst3_1, qst3_2, qst3_3, qst3_4,
      qst4_1, qst4_2, qst4_3, qst4_4, qst4_5,
      qst5_1, qst5_2, qst5_3, qst5_4, qst5_5,
      qst6_1, qst6_2, qst6_3, qst6_4, qst6_5
    } = this.state

    const values = {
      qst1_1, qst1_2,
      qst2_1, qst2_2, qst2_3, qst2_4,
      qst3_1, qst3_2, qst3_3, qst3_4,
      qst4_1, qst4_2, qst4_3, qst4_4, qst4_5,
      qst5_1, qst5_2, qst5_3, qst5_4, qst5_5,
      qst6_1, qst6_2, qst6_3, qst6_4, qst6_5
    }

    switch (step) {
      case 1:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions1
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 2:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions2
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              toResults={this.toResults}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 3:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions3
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 4:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions4
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 5:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions5
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 6:
        return (
          <>
            <TestNavigationBar step={step} />
            <TestQuestions6
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        )
      case 7:
        return (
          <TestResult values={values} />
        )
      default:
      // do nothing
    }

  }

}